var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"planetsContainer",staticClass:"background-planets-container"},_vm._l((_vm.selectedPlanets),function(planet){return _c('div',{key:`${planet.planet}-${planet.left}-${planet.top}`,staticClass:"planet",style:({
      top: planet.top,
      left: planet.left,
      width: planet.size,
      height: planet.size,
    })},[_c('img',{attrs:{"src":_vm.getPlanet(planet.src),"alt":"planet"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }